import { StateCreator } from "zustand";
import { WeeklyListsFilter } from "@publicPortal/pages/search/WeeklyLists/WeeklyListsFilter";

const defaultWeeklyListsFilter: WeeklyListsFilter = {
    dateCreatedFrom: null,
    dateCreatedTo: null,
};

export interface WeeklyListsSearchSlice {
    weeklyListsSearch: WeeklyListsFilter;
    setWeeklyListsSearch: (state: WeeklyListsFilter) => void;
    updateWeeklyListsSearch: (partialState: Partial<WeeklyListsFilter>) => void;
    resetWeeklyListsSearch: () => void;
}

export const createWeeklyListsSearchSlice: StateCreator<WeeklyListsSearchSlice, [], [], WeeklyListsSearchSlice> = (set) => ({
    weeklyListsSearch: defaultWeeklyListsFilter,
    setWeeklyListsSearch: (state) => set({ weeklyListsSearch: state }),
    updateWeeklyListsSearch: (partialState) => set((state) => ({ weeklyListsSearch: { ...state.weeklyListsSearch, ...partialState } })),
    resetWeeklyListsSearch: () => set({ weeklyListsSearch: { ...defaultWeeklyListsFilter } }),
});

